export class ApiError extends Error {
    status: number
    code: string
    fields: Record<string, string> | null

    constructor(status: number, code: string, fields: Record<string, string> | null) {
        super(code)
        this.name = 'ApiError'
        this.status = status
        this.code = code
        this.fields = fields
    }
}

interface RequestOptions {
    method?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE'
    body?: unknown
}

export const apiRequest = async <T = Record<string, unknown>>(path: string, options: RequestOptions = {}): Promise<T> => {
    const method = options.method ?? (options.body === undefined ? 'GET' : 'POST')

    let response: Response

    try {
        response = await fetch(path, {
            method,
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'udl'
            },
            body: options.body === undefined ? undefined : JSON.stringify(options.body)
        })
    }
    catch {
        throw new ApiError(0, 'network', null)
    }

    const data = await response.json().catch(() => ({})) as Record<string, unknown>

    if (!response.ok) {
        const code = typeof data.error === 'string' ? data.error : response.status === 413 ? 'file_too_large' : 'server_error'
        const fields = data.fields && typeof data.fields === 'object' ? data.fields as Record<string, string> : null

        throw new ApiError(response.status, code, fields)
    }

    return data as T
}

export const errorCode = (error: unknown): string => (error instanceof ApiError ? error.code : 'server_error')

export const errorFields = (error: unknown): Record<string, string> => (error instanceof ApiError && error.fields ? error.fields : {})
